<template>
  <!-- On Empty -->
  <div v-if="isEmpty" class="dropdown--cart p-3">
    <span>Váš nákupní <strong>košík je prázdný.</strong></span>
  </div>

  <div v-else class="dropdown--cart">
    <ul class="productList-list">
      <li v-for="(item, index) in basketitems" :key="index" class="productList view-tiny">
      <a class="productList-inner" :href="'/produkt/' + item.productSlug">
        <div class="productList-image thumbnail">
          <img
            :src="item.productPictureUrl"
            :alt="item.productName"
          />
        </div>
        <div class="productList-content">
          <div class="productList-desc">
            {{ item.productName }}
          </div>
          <div class="productList-price">
            {{ item.quantity }} ks,  <strong>{{ item.productPrice }} Kč</strong>
          </div>
        </div>
      </a>
        <button @click="onBasketItemDelete(item)" class="product-delete-btn">
          <BIcon icon="x-circle"></BIcon>
        </button>
      </li>
      <li class="summary">
        <span class="count-price">
            Celkem <strong>{{ basketItemsCount }} ks</strong> za <strong> {{ orderSubTotal }} Kč</strong>
        </span>
        <button @click.prevent="trashCart" class="dropdown--cart__button empty">Vysypat košík</button>
        <a href="/cart/" class="dropdown--cart__button">Objednat</a>
      </li>
    </ul>
  </div>
</template>

<script>

import store from '@/common/store'
import { BIcon, BIconXCircle } from 'bootstrap-vue'

export default {
  name: 'CartDropdown',
  components: {
    BIcon,
    BIconXCircle
  },
  props: {
    basketitems: Array
  },
  data() {
    return {
    }
  },
  methods: {
    trashCart(){
      store.dispatch("cartModule/trashBasket");
      window.location.reload();
    },
    onBasketItemDelete(item){
      store.commit("SHOW_LOADER", true);
      store.dispatch("cartModule/removeItem", { itemId: item.id })
          .then( (result) => store.commit("SHOW_LOADER", false));
    }
  },
  computed: {
    orderSubTotal() { return store.getters['cartModule/orderSubTotal'] },
    basketItemsCount() { return store.getters['cartModule/getBasketItemsCount'] },
    basketItems() { return store.getters['cartModule/getBasketItems'] },
    isEmpty(){
      return this.basketitems == null || this.basketitems.length <= 0;
    }
  },
}
</script>

<style scoped lang="scss">
.dropdown--cart{
  max-width: 500px;
    ul {
      padding: 0;
      margin: 0;
    }
  
    li.summary {
      display: -webkit-flex;
      display: flex;
      -webkit-flex-flow: row wrap;
      flex-flow: row wrap;
      background: #f5f5fa;
      //height: 65px;
      -webkit-align-items: center;
      align-items: center;
      border-radius: 0 0 5px 5px;
      padding: 15px;
    }

  li.summary a {
    margin: 0 0 0 auto;
    -webkit-flex: 120px 0 0;
    flex: 120px 0 0;
    height: 35px;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
    border-radius: 4px;
    background: #fff;
    color: #10476b;
  }

    li.summary a.empty {
      background: #fff;
      &:hover {
        background: #f8f9fa;
      }
    }

    li.summary a:last-of-type {
      margin-left: 10px;
      color: #fff;
      background: #279b37;
      &:hover {
        background: #1b6f27;
      }
    }

    .dropdown--cart__button {
        margin: 0 0 0 auto;
        -webkit-flex: 120px 0 0;
        flex: 120px 0 0;
        height: 35px;
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-align-items: center;
        align-items: center;
        border-radius: 2px;
        
        display: block;
        text-align: center;
        color: #000;
        background-color: #fff;
        border: none;
        -webkit-transition: background-color .3s;
        transition: background-color .3s;

        &:hover {
            background-color: #ebebeb;
        }
    }


    .dropdown--task {
        width: 20em;
        max-height: 20em;
        overflow-y: scroll;
    }

    span {
        display: block;
        text-align: center;
    }


    .productList {
        position: relative;
        padding: 5px;
        display: flex;
    }

    .productList-inner {
        display: block;
        text-decoration: none;
        color: #1c1c1d;
        -webkit-flex: 1 0 0;
        flex: 1 0 0;
        padding: 0 25px 0 0;
        min-width: 10%;
    }
  

    .productList.view-tiny {
        border-top: 0;
        -webkit-transition: background-color .3s;
        transition: background-color .3s;
    }

        .productList.view-tiny:hover {
            background-color: #ebebeb;
        }

        .productList.view-tiny .productList-image {
            position: absolute;
            top: 0;
            left: 10px;
            bottom: 0;
            margin: auto;
        }


        .productList.view-tiny .productList-price {
            float: none;
            font-family: "Droid Sans W02","Droid Sans",Helvetica,Arial,sans-serif;
            font-size: 15px;
        }

    .productList-price {
        clear: left;
        width: 65px;
        line-height: 1.3;
        font-size: 13px;
        text-align: right;
    }
  
    .product-delete-btn{
      border: none;
      width: 1em;
      height: 1em;
      display: inline-block;
      background: #d0d0d9;
      color: white;
      border-radius: 50%;
      -webkit-flex: 18px 0 0;
      flex: 1em 0 0;
      position: relative;
      padding: 0;
      margin: auto 10px;
      &:hover {
        background: #8c8c8f;
      }
    }



    .productList-image {
        width: 52px;
        height: 52px;
        float: left;
        margin: 0 15px 10px 0;
    }

    .productList.view-tiny .productList-desc {
        float: none;
        width: auto;
        text-align: left;
        padding-right: 10px;
        white-space: normal;
    }



    .thumbnail {
        display: inline-block;
        background: #fff;
        text-align: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
    }


        .thumbnail img {
            display: block;
            max-width: 100%;
            max-height: 100%;
            -o-object-fit: contain;
            object-fit: contain;
            margin: auto;
        }


    .productList-desc a, .productList-desc strong {
        display: block;
        text-transform: uppercase;
        font-size: 13px;
        overflow-wrap: break-word;
    }

    .productList.view-tiny .productList-inner {
        min-height: 52px;
        padding: 0;
        padding-left: 65px;
    }


    .productList.view-tiny .productList-desc {
        float: right;
        width: calc(100% - 67px);
        line-height: 1.4;
    }
  

    @media (min-width: 768px) {
        .productList-image {
            float: none;
            -webkit-box-flex: 0;
            -ms-flex: 0 0 52px;
            flex: 0 0 52px;
            margin: 0 15px 0 0;
        }

        .productList-content {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            position: relative;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
        }

        .productList-inner {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
        }

        .productList-price {
            float: none;
            margin: 0;
            width: auto;
            font-size: 14px;
        }

        .productList-desc {
            float: none;
            -webkit-box-flex: 1;
            -ms-flex: 1 1 100%;
            flex: 1 1 100%;
            margin: 0;
            width: auto;
        }
    }

}

@media (max-width: 767px) {
  .dropdown--cart{
    display: none;
  }
}

</style>
